export default __webpack_public_path__ + "static/media/3d-casual-life-looking-through-resumes.63b76730.png";